import {Dialog} from '@ui/overlays/dialog/dialog';
import {DialogHeader} from '@ui/overlays/dialog/dialog-header';
import {DialogBody} from '@ui/overlays/dialog/dialog-body';
import {useDialogContext} from '@ui/overlays/dialog/dialog-context';
import {Form} from '@ui/forms/form';
import {useForm} from 'react-hook-form';
import {Trans} from '@ui/i18n/trans';
import {FormTextField} from '@ui/forms/input-field/text-field/text-field';
import {Button} from '@ui/buttons/button';
import {DialogFooter} from '@ui/overlays/dialog/dialog-footer';
import {useAssignLicense} from './requests/use-assign-license';
import {useState} from 'react';
const ThemeColor = {
   cadetColor:"#1e90ff",
    nobleColor:"#009e60",
    regalColor:"#9238d3",
    royalColor:"#dc143c",
    eliteColor:"#A16750",
}

const PackageBadge = ({id, active = 1, forcom = false}: {id: number, active?: number, forcom?: boolean}) => {
  if (id == 1) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.cadetColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Basic
        </span>
      </span>
    );
  }
  if (id == 2) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.nobleColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Standard
        </span>
      </span>
    );
  }
  if (id == 3) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.regalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Ultra
        </span>
      </span>
    );
  }
  if (id == 4) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.royalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Premium
        </span>
      </span>
    );
  }

  if (id == 5) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.nobleColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Standard
        </span>
      </span>
    );
  }
  if (id == 6) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.royalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Premium
        </span>
      </span>
    );
  }
  if (id == 9) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.eliteColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Elite
        </span>
      </span>
    );
  }
  if (id == 0) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: '#a8a8a8',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Free
        </span>
      </span>
    );
  }
  return null;
};

interface AssignLicenseDialogProps {
  license: any;
}

interface FormData {
  username: string;
}

function getPackageName(packageId: number): string {
  const packageNames: Record<number, string> = {
    1: 'Basic',
    2: 'Standard',
    3: 'Ultra',
    4: 'Premium',
    9: 'Elite',
  };

  return packageNames[packageId] || `Package #${packageId}`;
}

export function AssignLicenseDialog({license}: AssignLicenseDialogProps) {
  const {close, formId} = useDialogContext();
  const [confirmedUser, setConfirmedUser] = useState<any>(null);
  const [checkBoxOne, setCheckBoxOne] = useState(false);
  const [checkBoxTwo, setCheckBoxTwo] = useState(false);
  const form = useForm<FormData>();
  const assignLicense = useAssignLicense(form);

  const handleSubmit = (data: FormData) => {
    if (!confirmedUser) {
      // First step: verify username
      assignLicense.mutate(
        {
          id: license.id,
          username: data.username,
          verify: true,
        },
        {
          onSuccess: response => {
            if (response.data) {
              setConfirmedUser(response.data);
            }
          },
        },
      );
    } else {
      // Second step: confirm assignment (only if checkboxes are checked)
      if (!checkBoxOne || !checkBoxTwo) {
        return; // Don't proceed if checkboxes aren't checked
      }
      
      assignLicense.mutate(
        {
          id: license.id,
          username: form.getValues('username'),
          verify: false,
        },
        {
          onSuccess: () => {
            close();
          },
        },
      );
    }
  };

  return (
    <Dialog size="md">
      <DialogHeader>
        <Trans message="Assign License" />
      </DialogHeader>
      {assignLicense.error && (
        <div className="mx-24 mb-16 p-12 bg-danger/10 border border-danger rounded text-sm text-danger">
          {assignLicense.error.message}
        </div>
      )}
      <DialogBody>
        <Form form={form} id={formId} onSubmit={handleSubmit}>
          <div className="space-y-16 mb-16">
            <div className="flex justify-between gap-12 p-12 bg-alt rounded">
              <div>
                <div className="text-xs text-muted mb-4">
                  <Trans message="Package" />
                </div>
                <div className="text-sm font-medium">
                  <PackageBadge id={license.package_id} active={1} forcom={false} />
                </div>
              </div>
              <div className="text-right">
                <div className="text-xs text-muted mb-4">
                  <Trans message="License Key" />
                </div>
                <div className="text-sm font-medium">{license.key}</div>
              </div>
            </div>

            <div className="flex justify-between gap-12 text-sm">
              <div>
                <div className="text-xs text-muted mb-4">
                  <Trans message="Order ID" />
                </div>
                <div className="font-medium">#{license.id}</div>
              </div>
              <div>
                <div className="text-xs text-muted mb-4">
                  <Trans message="Order Date" />
                </div>
                <div className="font-medium">{license.order_date}</div>
              </div>
            </div>

            {!confirmedUser ? (
              <FormTextField
                name="username"
                label={<Trans message="Username" />}
                placeholder="Enter username..."
                required
                autoFocus
              />
            ) : (
              <>
                {/* User Information Display */}
                <div className="border rounded flex flex-row align-items-center mb-16 p-12 bg-alt">
                  <div className="p-8">
                    <img 
                      src={confirmedUser?.avatar || "/images/avatar.jpg"} 
                      style={{width: 60, height: 60, borderRadius: '50%', objectFit: 'cover'}} 
                      alt="User Avatar"
                    />
                  </div>
                  <div className="flex-1">
                    <h6 className="font-semibold mb-4">{confirmedUser?.username}</h6>
                    <h6 className="text-sm text-muted mb-2">
                      {confirmedUser?.first_name} {confirmedUser?.last_name}
                    </h6>
                    <h6 className="text-sm text-muted">
                      {[confirmedUser?.city, confirmedUser?.state, confirmedUser?.country]
                        .filter(Boolean)
                        .join(', ')}
                    </h6>
                  </div>
                </div>

                {/* Confirmation Checkboxes */}
                <div className="p-12 mb-16 border rounded">
                  <div className="mb-12">
                    <div className="flex flex-row align-items-start">
                      <div className="me-8 mt-4">
                        <input 
                          type="checkbox" 
                          checked={checkBoxOne}
                          onChange={() => setCheckBoxOne(!checkBoxOne)} 
                        /> 
                      </div>
                      <div className="text-sm">
                        I confirm that I know the assignee and wish to assign the above-mentioned license key to the assignee on my sole responsibility.
                      </div>
                    </div>
                  </div>
                  
                  <div className="mb-0">
                    <div className="flex flex-row align-items-start">
                      <div className="me-8 mt-4">
                        <input 
                          type="checkbox" 
                          checked={checkBoxTwo}
                          onChange={() => setCheckBoxTwo(!checkBoxTwo)} 
                        /> 
                      </div>
                      <div className="text-sm">
                        I know that once assignee utilizes this license key, the transaction is irreversible.
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Form>
      </DialogBody>
      <DialogFooter>
        <Button onClick={close} variant="outline">
          <Trans message="Cancel" />
        </Button>
        <Button
          form={formId}
          type="submit"
          variant="flat"
          color="primary"
          disabled={assignLicense.isPending || (confirmedUser && (!checkBoxOne || !checkBoxTwo))}
        >
          {!confirmedUser ? (
            <Trans message="Verify User" />
          ) : (
            <Trans message="Confirm Assignment" />
          )}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
